// Same rule as the router guard and authStore.isStaff: the driver APK, or a staff role in the claims.
// Such a session is always sent to the staff screens (/staffRoutes/, /staff/..., /account/).
export const isStaffSession = (
  customClaims: Record<string, any> | null | undefined,
  apk: string | undefined = typeof window !== 'undefined' ? window.apk : undefined,
): boolean => {
  const allowedRoles = customClaims?.['x-hasura-allowed-roles']
  return apk === 'driver' || (Array.isArray(allowedRoles) && allowedRoles.includes('staff'))
}
